export enum BookingStatusEnum {
    PENDING = 'pending',
    CONFIRMED = 'confirmed',
    CANCELLED = 'cancelled',
    CANCELLED_BY_DINER = 'cancelled_by_diner',
}